"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asynciterator_1 = require("asynciterator");
/**
 * An {@link AsyncReiterable} that is backed by an array.
 */


var AsyncReiterableArray =
/*#__PURE__*/
function () {
  function AsyncReiterableArray(array, terminate) {
    _classCallCheck(this, AsyncReiterableArray);

    this.array = array.slice();
    this.iterators = [];

    if (terminate) {
      this.array.push(null);
    }
  }
  /**
   * Create a new {@link AsyncReiterableArray} with the given data elements
   * that will be ended.
   * @param {T[]} array An array of data elements.
   * @return {AsyncReiterableArray<T>} A new ended {@link AsyncReiterableArray} with the given data elements.
   */


  _createClass(AsyncReiterableArray, [{
    key: "iterator",
    value: function iterator() {
      if (this.isEnded()) {
        return new asynciterator_1.ArrayIterator(this.array.slice(0, this.array.length - 1));
      }

      var iterator = new asynciterator_1.BufferedIterator();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var data = _step.value;
          AsyncReiterableArray.pushToIterator(iterator, data);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.iterators.push(iterator);
      return iterator;
    }
  }, {
    key: "push",
    value: function push(data) {
      if (this.isEnded()) {
        throw new Error('Can not push data anymore into an AsyncReiterableArray after it has been terminated.');
      }

      this.array.push(data);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.iterators[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var iterator = _step2.value;
          AsyncReiterableArray.pushToIterator(iterator, data);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "isEnded",
    value: function isEnded() {
      return this.array.length > 0 && this.array[this.array.length - 1] === null;
    }
  }], [{
    key: "fromFixedData",
    value: function fromFixedData(array) {
      return new AsyncReiterableArray(array, true);
    }
    /**
     * Create a new {@link AsyncReiterableArray} with the given data elements
     * that will not be ended.
     * @param {T[]} initialData An array of initial data elements.
     * @return {AsyncReiterableArray<T>} A new open-ended {@link AsyncReiterableArray} with the given data elements.
     */

  }, {
    key: "fromInitialData",
    value: function fromInitialData(initialData) {
      return new AsyncReiterableArray(initialData, false);
    }
    /**
     * @return {AsyncReiterableArray<T>} A new open-ended {@link AsyncReiterableArray} without data elements.
     */

  }, {
    key: "fromInitialEmpty",
    value: function fromInitialEmpty() {
      return AsyncReiterableArray.fromInitialData([]);
    }
  }, {
    key: "pushToIterator",
    value: function pushToIterator(iterator, data) {
      if (data === null) {
        iterator.close();
      } else {
        iterator._push(data);
      }
    }
  }]);

  return AsyncReiterableArray;
}();

exports.AsyncReiterableArray = AsyncReiterableArray;